import router from '@/router';
import { instBundle } from '@/axios.js';
import { addAuthCookie } from '@/util.js';

const axios = instBundle.axios;

const state = {
	idRegister: null,
	name: null,
	adminLevel: null,
	iat: null,
	exp: null,
	Authorization: '',
	department: null,
};

const getters = {
	Authorization(state, getters, rootState) {
		return `Bearer ${state.Authorization}`;
	},
};

const mutations = {
	init(state) {
		state.idRegister = null;
		state.name = null;
	},
	idRegister(state, v) {
		state.idRegister = v;
	},
	name(state, v) {
		state.name = v;
	},
	adminLevel(state, v) {
		state.adminLevel = v;
	},
	iat(state, v) {
		state.iat = v;
	},
	exp(state, v) {
		state.exp = v;
	},
	Authorization(state, v) {
		state.Authorization = v;
	},
};

const actions = {
	async tokenVerify({ rootState, commit, state }) {
		try {
			const cookie = document.cookie;
			let access_token = localStorage.getItem('access_token');
			if (!access_token && cookie) {
				const cookieObj = cookie.split(';').reduce((acc, cur) => {
					const arr = cur.trim().split('=');
					acc[arr[0]] = arr[1];
					return acc;
				}, {});
				access_token = cookieObj.authenticate;
			}
			if (!access_token) return false;
			const params = { jwt: access_token };
			const options = {
				headers: {
					'x-api-key': 'b9d54cc0-5ea5-11ea-b7f9-41b4f2de8659',
				},
			};
			const { data } = await axios.post(
				`${rootState.env.authDomain}/public/auth/admin/token/verify`,
				params,
				options
			);
			const authorization =
				localStorage.getItem('access_token') || access_token;
			addAuthCookie(authorization);
			commit('Authorization', authorization);
			commit('idRegister', data.idRegister);
			commit('name', data.nickName);
			commit('adminLevel', Number(data.adminLevel));
			commit('iat', data.iat * 1000);
			commit('exp', data.exp * 1000);
			state.department = data.department;
			return true;
		} catch (err) {
			console.error(err);
			return false;
		}
	},
	logout({ rootState, state }, noReload) {
		const domain = rootState.env.cookieDomain;
		document.cookie = `authenticate=;expires=${new Date(0)};path=/;domain=${domain}`;
		document.cookie = `login=;expires=${new Date(0)};path=/;domain=${domain}`;
		state.idRegister = null;
		state.name = null;
		state.Authorization = '';
		state.department = null;
		localStorage.removeItem('access_token');
		localStorage.removeItem('refresh_token');
		if (!noReload) {
			window.location.reload();
		}
	},
};

export default { namespaced: true, state, getters, mutations, actions };
